import { Component, OnInit } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss'],
})
export class RewardsComponent {
  loader: boolean;
  ads: any;
  orgObj: any;
  orgName;
  picload: boolean;
  orgId = localStorage.getItem('organizationId');
  newOrgObject;
  constructor(public service: ApiService, public handler: HandlerService, public router: Router,private bottomSheet: MatBottomSheet,public auth:AuthService) { }

  ionViewWillEnter() {
    sessionStorage.setItem('orgId',this.orgId)
    this.picload = true;
      this.getRewards()
  }
  imageConversion(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (res: any) => {
      let img = document.getElementById('image');
      img.setAttribute('src', res.target.result);
    }
  }


  details(id) {
    this.router.navigate(['/reward-details',id]);
  }
  
  openBottomSheetOrg(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.newOrgObject,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(res){
      this.loader=true;
      this.orgName = res.name;
      this.orgId = res.id;
      this.getRewardsOrgBased(res.id)
    }
     });
  }

  getRewards(){
    this.service.getRewardAds().subscribe((res: any) => {
      if (res) {
        if (res.length > 0) {
          this.ads = res;
          this.ads = this.ads.filter(res => { return res.adType == 1 });
          this.ads.map((res, i) => {
            if (res.referenceDocsD && res.referenceDocsD.length > 0) {
              this.picload = true;
              let dev1=res.referenceDocsD.find(res=>{ return res.deviceType==1});
              if(dev1){
              this.service.getImage(dev1.id).subscribe(res => {
                let binary = new Uint8Array(res)
                let blob = new Blob([binary], { type: 'image/gif' });
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = (res1: any) => {
                  this.ads[i].pic = res1.target.result;
                  this.picload = false;
                }
              })
            }
            }
            else{
              this.picload = true;
              this.service.getImage(res.documentId).subscribe(res => {
                let binary = new Uint8Array(res)
                let blob = new Blob([binary], { type: 'image/gif' });
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = (res1: any) => {
                  this.ads[i].pic = res1.target.result;
                  this.picload = false;
                }
              })
            }
          })
        }
        else {
          this.picload = false;
        }
      }
      else {
        this.handler.res("No Vouchors available");
        this.picload = false;
      }
    }, err => {
      this.handler.err(err);
      this.picload = false;
    })
  }
  getRewardsOrgBased(id){
    this.service.getRewardAdsOrgBased(id).subscribe((res: any) => {
      if (res) {
        if (res.length > 0) {
          this.ads = res;
          this.ads = this.ads.filter(res => { return res.adType == 1 });
          this.ads.map((res, i) => {
            if (res.referenceDocsD && res.referenceDocsD.length > 0) {
              this.picload = true;
              let dev1=res.referenceDocsD.find(res=>{ return res.deviceType==1});
              if(dev1){
              this.service.getImage(dev1.id).subscribe(res => {
                let binary = new Uint8Array(res)
                let blob = new Blob([binary], { type: 'image/gif' });
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = (res1: any) => {
                  this.ads[i].pic = res1.target.result;
                  this.picload = false;
                }
              })
            }
            }
            else{
              this.picload = true;
              this.service.getImage(res.documentId).subscribe(res => {
                let binary = new Uint8Array(res)
                let blob = new Blob([binary], { type: 'image/gif' });
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = (res1: any) => {
                  this.ads[i].pic = res1.target.result;
                  this.picload = false;
                }
              })
            }
          })
        }
        else {
          this.picload = false;
        }
      }
      else {
        this.handler.res("No Vouchors available");
        this.picload = false;
        this.ads=[]
      }
    }, err => {
      this.handler.err(err);
      this.picload = false;
    })
  }

}
